import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AxiosInstance from "../utils/AxiosInstance";
import Messages from "../constants/Messages";
import { useShowAlert } from "../context/AlertContext";
import handleError from "../constants/handleError";
import PreLoader from "../constants/PreLoader";
import { TEMPLATE_MAP } from "./templateRegistry";

export default function Sale() {
  const [searchParams] = useSearchParams();
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const showAlert = useShowAlert();
  const [templateId, setTemplateId] = useState(null);
  const token = searchParams.get("token");
  const option = searchParams.get("option");
  const setting = searchParams.get("setting");
  const parsedSetting = setting ? JSON.parse(setting) : null;


  const handleShareData = async () => {
    console.log("handleShareData")
    if (!token) {
      showAlert("error", Messages.ERROR.INVALID_TOKEN || "Invalid token!");
      return;
    }

    setLoading(true);
    try {
      const response = await AxiosInstance.get(
        `/module/sale/verify/share/${token}`,
      );
    

console.log("API Result:", response.data.results);
      setData(response.data.results);
      setTemplateId(
  response.data.results?.storeSettings?.invoiceSettings?.template?.templateId
);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading(false);
    }
  };
  const SelectedTemplate = TEMPLATE_MAP[templateId?.slice(0, 6)];

  useEffect(() => {
    handleShareData();    
  }, [token]);

  if (isLoading) return <PreLoader isLoading={isLoading} />;

  return (
    <div>
        {SelectedTemplate && (
      <SelectedTemplate
        isData={data}
        // option={option}
        // storeSettings={parsedSetting}
      />
    )}
    </div>
  );
}
